import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

interface MaskBadgeProps {
  maskName: string;
  className?: string;
  variant?: "default" | "secondary" | "destructive" | "outline";
}

// Generate consistent colors for mask names
const getMaskColor = (maskName: string): string => {
  const colors = [
    "bg-blue-100 text-blue-800 hover:bg-blue-200",
    "bg-green-100 text-green-800 hover:bg-green-200",
    "bg-purple-100 text-purple-800 hover:bg-purple-200",
    "bg-orange-100 text-orange-800 hover:bg-orange-200",
    "bg-pink-100 text-pink-800 hover:bg-pink-200",
    "bg-indigo-100 text-indigo-800 hover:bg-indigo-200",
    "bg-teal-100 text-teal-800 hover:bg-teal-200",
    "bg-red-100 text-red-800 hover:bg-red-200",
  ];

  // Create a simple hash from the mask name to ensure consistency
  let hash = 0;
  for (let i = 0; i < maskName.length; i++) {
    const char = maskName.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash; // Convert to 32-bit integer
  }

  return colors[Math.abs(hash) % colors.length];
};

export function MaskBadge({ maskName, className, variant = "secondary" }: MaskBadgeProps) {
  const handleClick = () => {
    // Navigate to the masks page with the specific mask selected
    // You can modify this to navigate to a specific mask detail page if needed
  };

  const colorClass = getMaskColor(maskName);

  return (
    <Badge
      variant={variant}
      className={cn("cursor-pointer transition-colors", colorClass, className)}
      onClick={handleClick}
    >
      {maskName}
    </Badge>
  );
}
